import { GroupStateRoundedSides } from "@intelligems/ig-types";

export const getRounded = function (order: number, numberOfGroups: number) {
  let round: GroupStateRoundedSides = "";
  if (order === 0) {
    round = "left";
    if (order === numberOfGroups - 1) {
      round = "both";
    }
  } else if (order === numberOfGroups - 1) {
    round = "right";
  }
  return round;
};
